import { ReactComponent as EmptySchedule } from "assets/svg/empty-schedule.svg";
import { useCalendarTime } from "components/Dashboard/DoctorDashboard/views/one-one-sessions/contexts/CalendarTimeContext";
import messages from "messages";
import { useCallback } from "react";
import { Button } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { showAddToCalendar } from "store/calendarSidebarSlice";
import DayPreviewBadge from "../../../../../calendar-sidebar/components/day-preview/day-preview-badge/DayPreviewBadge";
import useEventsForDay from "../../../../../calendar-sidebar/components/day-preview/hooks/use-events-for-day";
import styles from "./DayPreviewMobile.module.scss";
import moment from "moment-timezone";

const DayPreviewMobile = () => {
  const dispatch = useDispatch();
  const { anchorTime, currentCalendarTimezone } = useCalendarTime();

  const { eventsForDay } = useEventsForDay(
    moment.tz(anchorTime, currentCalendarTimezone).startOf("day").valueOf(),
  );

  const addToCalendar = useCallback(
    () =>
      dispatch(
        showAddToCalendar({
          hasInitialTime: false,
          defaultStartTime: anchorTime,
        }),
      ),
    [dispatch, anchorTime],
  );

  return (
    <div className={styles.container}>
      <div className={styles.content}>
        {eventsForDay.length === 0 && (
          <div className={styles.empty}>
            <EmptySchedule />
            <div>{messages.nothingBookedForTheDay}</div>
          </div>
        )}
        {eventsForDay.map((event) => (
          <DayPreviewBadge key={event.id} event={event} />
        ))}
        <Button
          variant={"primary"}
          onClick={addToCalendar}
          className={styles.button}
        >
          {messages.addToCalendar}
        </Button>
      </div>
    </div>
  );
};

export default DayPreviewMobile;
